<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1" />
        <b-breadcrumb :items="items_eng" v-else-if="thai_student==0" />
        <b-breadcrumb  v-else />
      </div>
      <create-bio  ></create-bio>
      <create-main ></create-main >
    </div>
  </div>
</template>

<script>
import CreateMain from "../../components/CreateMain.vue";
import CreateBio from "../../components/CreateBio.vue";

export default {
  components: {
    CreateMain,
    CreateBio
  },
  name: "News",
  data() {
    return {
      items: [
        {
          text: "ออกจากระบบ",
          href: "#/logout"
        },
        {
          text: "หน้าหลัก",
          href: "#/main"
        }
      ],
      items_eng: [
        {
          text: "Logout",
          href: "#/logout"
        },
        {
          text: "Home",
          href: "#/main"
        }
      ],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {
    if (this.$store.state.user !=null) {
      this.thai_student = this.$store.state.user.thaistudent;
    }else{
      this.$router.push("/Login");
    }
  }
};
</script>
<style>
</style>
